@if (isLoggedIn) {
  <hpo-layout [backendBaseUri]="backendBaseUri"
    [claims]="claims"
    [currentUser]="currentUser"
    [environmentVariables]="environmentVariables"
    [floatingActionButtonTemplate]="floatingActionButtonContent"
    [locationUri]="locationUri"
    [menuIsHidden]="hideLayoutMenu"
    [menuItems]="menuItems"
    [fullscreen]="enableFullScreenMode"
    [accountBaseUri]="accountBaseUri"
    [portalBaseUri]="portalBaseUri"
    [backendPortalUri]="backendPortalUri"
    [mainTemplate]="mainContent"
    [productId]="productId"
    [productionMode]="productionMode"
    applicationName="IWI"
    applicationNameShort="IWI"
    [appVersion]="appVersion"
    (logoutClicked)="logOut()">
  </hpo-layout>
  <ng-template #floatingActionButtonContent>
    <hpo-floating-action-button id="app-bar-fab"
      [mobile]="mobile" />
  </ng-template>
  <ng-template #mainContent>
    <router-outlet></router-outlet>
  </ng-template>
}

@if (!isLoggedIn) {
  <div>
    <router-outlet></router-outlet>
  </div>
}